const backendUrl = process.env.BACKEND_URL || "localhost:1337";

export const AVATAR_API = "https://ui-avatars.com/api";
export const API = `https://${backendUrl}/api`;
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";